import Vue from 'vue';

import FilterBigInt from './FilterBigInt.vue';
import StubFilterBigInt from './StubFilterBigInt.vue';
export const AG_GRID_FILTER_BIGINT = 'agInlineBigIntColumnFilter';
Vue.component(AG_GRID_FILTER_BIGINT, FilterBigInt);
export const AG_GRID_FILTER_STUB_BIGINT = 'agColumnFilterStubBigInt';
Vue.component(AG_GRID_FILTER_STUB_BIGINT, StubFilterBigInt);

import FilterDateTime from './FilterDateTime.vue';
import StubFilterDateTime from './StubFilterDateTime.vue';
export const AG_GRID_FILTER_DATE_TIME = 'agInlineDateTimeColumnFilter';
Vue.component(AG_GRID_FILTER_DATE_TIME, FilterDateTime);
export const AG_GRID_FILTER_STUB_DATE_TIME = 'agColumnFilterStubDateTime';
Vue.component(AG_GRID_FILTER_STUB_DATE_TIME, StubFilterDateTime);

import FilterDecimal from './FilterDecimal.vue';
import StubFilterDecimal from './StubFilterDecimal.vue';
export const AG_GRID_FILTER_DECIMAL = 'agInlineDecimalColumnFilter';
Vue.component(AG_GRID_FILTER_DECIMAL, FilterDecimal);
export const AG_GRID_FILTER_STUB_DECIMAL = 'agColumnFilterStubDecimal';
Vue.component(AG_GRID_FILTER_STUB_DECIMAL, StubFilterDecimal);

import FilterSelect from './FilterSelect.vue';
import StubFilterSelect from './StubFilterSelect.vue';
export const AG_GRID_FILTER_SELECT = 'agSelectColumnFilter';
Vue.component(AG_GRID_FILTER_SELECT, FilterSelect);
export const AG_GRID_FILTER_STUB_SELECT = 'agColumnFilterStubSelect';
Vue.component(AG_GRID_FILTER_STUB_SELECT, StubFilterSelect);

import FilterSelectMultiple from './FilterSelectMultiple.vue';
import StubFilterSelectMultiple from './StubFilterSelectMultiple.vue';
export const AG_GRID_FILTER_SELECT_MULTIPLE = 'agSelectMultipleColumnFilter';
Vue.component(AG_GRID_FILTER_SELECT_MULTIPLE, FilterSelectMultiple);
export const AG_GRID_FILTER_STUB_SELECT_MULTIPLE = 'agColumnFilterStubSelectMultiple';
Vue.component(AG_GRID_FILTER_STUB_SELECT_MULTIPLE, StubFilterSelectMultiple);

import FilterText from './FilterText.vue';
import StubFilterText from './StubFilterText.vue';
export const AG_GRID_FILTER_TEXT = 'agInlineTextColumnFilter';
Vue.component(AG_GRID_FILTER_TEXT, FilterText);
export const AG_GRID_FILTER_STUB_TEXT = 'agColumnFilterStubText';
Vue.component(AG_GRID_FILTER_STUB_TEXT, StubFilterText);

// Vue uses JSON.stringify to serialize filters,
// which doesn't work with BigInt (until this change)
Object.defineProperty(BigInt.prototype, 'toJSON', {
  value: function () {
    return `${this}n`;
  },
  writable: false,
  enumerable: false,
  configurable: false,
});
